import React, { useState } from 'react';
import { Mic } from 'lucide-react';
import classNames from 'classnames';
import './VoicePluginButton.scss';

export default function VoicePluginButton({ onClick, voiceConfiguration }) {
  const [hovered, setHovered] = useState(false);

  const showTooltip =
    !!voiceConfiguration?.web_voice_widget_configuration
      ?.show_chat_button_callout;
  const tooltipText =
    voiceConfiguration?.web_voice_widget_configuration
      ?.chat_button_callout_text || 'Chat with the Bot';

  const position =
    voiceConfiguration?.web_voice_widget_configuration?.chat_plugin_position ||
    'bottom-right';

  const positionAdjustment = window.PROSPERA_WEB_CHAT_INSTALLED
    ? 'inner-button'
    : '';

  return (
    <div
      className={classNames(
        'prospera-fixed-container',
        position,
        positionAdjustment
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className={classNames('prospera-tooltip-container', {
          'has-tooltip': showTooltip,
        })}
      >
        <button
          onClick={onClick}
          className={classNames('prospera-button', {
            'prospera-bg-primary':
              !voiceConfiguration?.web_voice_widget_configuration
                ?.chat_button_color,
          })}
          style={
            voiceConfiguration?.web_voice_widget_configuration
              ?.chat_button_color
              ? {
                  backgroundColor:
                    voiceConfiguration?.web_voice_widget_configuration
                      ?.chat_button_color,
                }
              : undefined
          }
        >
          <div className="prospera-button-inner">
            {hovered && <span className="prospera-hover-overlay" />}
            <Mic className="prospera-mic-icon" />
          </div>
        </button>
        {showTooltip && (
          <div
            className={classNames('prospera-tooltip-bubble', {
              'tooltip-left':
                position === 'bottom-right' || position === 'top-right',
              'tooltip-right':
                position === 'bottom-left' || position === 'top-left',
              'tooltip-top': position === 'bottom-center',
              'tooltip-bottom': position === 'top-center',
            })}
          >
            {tooltipText}
          </div>
        )}
      </div>
    </div>
  );
}
